import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import RedButton from 'app/components/buttons/RedButton';
import Loading from 'app/components/loaders/Loading';

import useApi from 'app/context/useApi';

import { paper } from 'app/styles/core';

const useStyles = makeStyles(theme => ({
    paper: {
        ...paper(theme),
        position: 'relative',
        marginBottom: theme.spacing(3)
    },
    marginTop: {
        marginTop: theme.spacing(3),
    },
}))

export default function Settings(props) {

    const classes = useStyles();
    const api = useApi();

    const [ password, setPassword ] = useState("");
    const [ errorMessage, setErrorMessage ] = useState(false);

    const [ deleteAccountLoading, setDeleteAccountLoading ] = useState(false);
    const [ verifyDeleteAccountDialogOpen , setVerifyDeleteAccountDialogOpen ] = useState(false);

    const verifyDeleteAccount = () => {
        setVerifyDeleteAccountDialogOpen(true);
    }

    const handleDeleteAccountCancel = () => {
        setVerifyDeleteAccountDialogOpen(false);
    }

    const handlePassword = event => {
        setPassword(event.target.value);
    }

    const deleteAccount = e => {
        e.preventDefault();
        setDeleteAccountLoading(true);
        setErrorMessage(false);

        const data = {
            password: password
        }

        api.post('/profile/settings/delete-account', data)
            .catch(error => {
                setDeleteAccountLoading(false);
                if (error?.response?.data?.errors) {
                    setErrorMessage(error.response.data.errors.password[0])
                }
            });
    }

    return (
        <form
            noValidate
            autoComplete="off"
            >
            <Paper className={classes.paper}>
                <Grid container
                    alignItems="center"
                    justify="space-between"
                    spacing={3}
                    >
                    <Grid item>
                        <Typography variant="h6" component="h3" gutterBottom>
                            Settings
                        </Typography>
                    </Grid>
                </Grid>
                <Typography color="textSecondary">
                    Here you can adjust your personal settings. Associated clubs do not have access to these settings even if you are allowing them to modify your profile, membership settings, payment and security.
                </Typography>
            </Paper>
            <Paper className={classes.paper}>
                <Loading isLoading={deleteAccountLoading}/>
                <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    spacing={3}
                    >
                    <Grid item>
                        <Typography variant="h6" component="h3" gutterBottom>
                            Delete Account
                        </Typography>
                    </Grid>
                </Grid>
                <Typography color="textSecondary" gutterBottom>
                    Deleting your account will delete all associated posts, comments and any other relevant data. You will not have the ability to access and adjust your profile, pay your dues online, receive important emails from your associated organizations as well as other online features like purchasing event tickets and proposals. Administrators may still have access to your profile and you will need to contact any organizations you belong to directly to have them remove your information from our platform.
                </Typography>
                <Typography align="right" component="div" className={classes.marginTop}>
                    <RedButton
                        disabled={deleteAccountLoading}
                        variant="contained"
                        onClick={verifyDeleteAccount}
                        >
                        Delete Account
                    </RedButton>
                </Typography>
            </Paper>
            <Dialog
                open={verifyDeleteAccountDialogOpen}
                onClose={handleDeleteAccountCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">Confirm you want to Delete your Account</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete your account? We believe a better method is to discuss with your organization administrators how to help protect your account from the administrative side.
                    </DialogContentText>
                    <TextField
                        id="input-password"
                        label="Password"
                        value={password}
                        onChange={handlePassword}
                        variant="outlined"
                        fullWidth
                        type="password"
                        name="password"
                        margin="normal"
                        helperText="Please confirm your password to continue."
                    />
                    { (errorMessage) &&
                        <Alert severity='error'>{errorMessage}</Alert>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteAccountCancel} color="primary" autoFocus>
                        Cancel
                    </Button>
                    <RedButton onClick={deleteAccount} variant="contained">
                        Delete Account
                    </RedButton>
                </DialogActions>
            </Dialog>
        </form>
    )
}
